module.exports = __webpack_public_path__ + "fcbc0ded7a4b78b7ae833cd20dd3d7b1.svg";